module.exports = __webpack_public_path__ + "static/ntl_cover-a632192e6e7ef869c925a2eef4ad917d.png";